import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/map';
import {Observable} from "rxjs/Observable";
import {AlertController, App, LoadingController, NavController} from 'ionic-angular';
import {SubscriptionServerProvider} from "../../providers/subscription-server/subscription-server";
import {AlertProvider} from '../../providers/alert/alert';
import {AuthProvider} from '../auth/auth';
import {Storage} from '@ionic/storage';
import {SystemProvider} from '../../providers/system/system';
//import { EventEmitterProvider } from '../../providers/event-emitter/event-emitter';
import * as Config from "../../app/app.config";

let httOptions = {
  headers: new Headers({
    'Access-Control-Allow-Origin': '*',
  })
};

@Injectable()
export class PaymentHttpProvider {

  private user: any;
  private data: any;

  datalogin: any = {
    email: '',
    password: ''
  };

  datasession: any = {
    email: '',
    token: ''
  };

  constructor(
    public http: Http,
    public loadingCtrl: LoadingController,
    private alertProvider: AlertProvider,
    public alertCtrl: AlertController,
    private app: App,
    private subscriptionServerProvider: SubscriptionServerProvider,
    private authProvider: AuthProvider,
    private storage: Storage,
    private systemProvider: SystemProvider
  ) {
    console.log('Hello PaymentHttpProvider Provider');
  }

  //private dataNewSubscription: any;
  //private dataNewSubscriptionPayment: any;
  private get navCtrl(): NavController {
    // (getRootNav) is deprecated and will be removed in the next major release. Use getRootNavById instead.
    // App.getRootNav
    // return this.app.getRootNav();
    return this.app.getRootNavs()[0]
  }

  createApplicationHeaders() {
    let headers = new Headers();
    headers.append('Application', JSON.stringify({
      'version': Config.version,
      'applicationId': Config.applicationId
    }));

    return headers;
  }

  createApplicationHeadersWithBearer() {
    let headers = this.createApplicationHeaders();
    headers.append('Authorization', 'Bearer ' + Config.tokenPS);

    return headers;
  }

  checkApi(): Observable<Object> {
    return this.http.get(Config.baseUrlGateway + 'check')
      .map(response => response.json());
  }

  checkInstallments(): Observable<Object> {
    return this.http.get(Config.baseUrlGateway + 'check')
      .map(response => response.json());
  }

  dologin(email, password) {
    this.datalogin.email = email;
    this.datalogin.password = password;
    return this.http.post(Config.baseUrlGateway + 'login', this.datalogin)
      .map((res: Response) => {
        this.data = res.json();
        return this.data;
      });
  }

  checkSessionLogin() {
    let headers = this.createApplicationHeadersWithBearer();
    return this.http.get(Config.baseUrlGateway + 'sessionLogin', {headers: headers})
      .map((res: Response) => res.json());

  }

  getSession(email, token) {
    let headers = this.createApplicationHeadersWithBearer();
    this.datasession.email = email;
    this.datasession.token = token;
    return this.http.post(Config.baseUrlGateway + 'session', this.datasession, {headers: headers})
      .map((res: Response) => res.json());
  }

  public doFree(formData: any) {
    let headers = this.createApplicationHeadersWithBearer();
    let that = this;
    let loader = this.loadingCtrl.create({
      content: 'Processando ....',
      //duration: 3000
    });

    let dataNewSubscription = formData;
    let voucherId = null;
    let voucherDiscountTotal = null;
    if (formData.voucherId !== undefined) {
      voucherId = formData.voucherId;
      voucherDiscountTotal = formData.voucherDiscountTotal;
    }
    dataNewSubscription['voucherId'] = voucherId;
    dataNewSubscription['voucherDiscountTotal'] = voucherDiscountTotal;

    loader.present();
    return Observable.create((observer: any) => {
      this.subscriptionServerProvider.doSubByPaymentFree(dataNewSubscription).subscribe((data: any) => {
        loader.dismiss();
        this.showInsertOkFree();
        //  this.navCtrl.setRoot('MainPage');
        //  this.navCtrl.popToRoot({
        //    animation: 'ios-transition'
        //  });
      });
    });


  }

  public doBilletVindi(formData: any, paymentType) {
    let headers = this.authProvider.createApplicationHeadersWithBearer();
    let that = this;
    let loader = this.loadingCtrl.create({
      content: 'Gerando a Fatura, aguarde ....',
      //duration: 3000
    });

    let voucherId = null;
    let voucherDiscountTotal = null;
    if (formData.voucherId !== undefined) {
      voucherId = formData.voucherId;
      voucherDiscountTotal = formData.voucherDiscountTotal;
    }

    loader.present();
    return Observable.create((observer: any) => {
      this.http.post(Config.baseUrl + '/users/me/vindi/' + paymentType, formData, {headers: headers})
        .subscribe((formData) => {
          if (formData.ok === true) {
            let dataNewSubscription = formData.json();
            console.log(dataNewSubscription);
            dataNewSubscription['voucherId'] = voucherId;
            dataNewSubscription['voucherDiscountTotal'] = voucherDiscountTotal;

            this.subscriptionServerProvider.doSubByPaymentBillet(dataNewSubscription).subscribe((data: any) => {
              loader.dismiss();
              this.showInsertOkBillet();
            });
          }
        }, (error: any) => {
          console.log(error);
          loader.dismiss();
          that.alertProvider.doAlert(error._body, 'Atenção');
          observer.next(null);
          observer.complete();
        });
    });
    //  .map((res: Response) => res.json());
  }

  public cancelBillsVindi(paymentCode) {
    let headers = this.authProvider.createApplicationHeadersWithBearer();
    let that = this;

    return Observable.create((observer: any) => {
      this.http.post(Config.baseUrl + '/users/me/vindi/delete/' + paymentCode, {headers: headers})
        .subscribe((formData) => {
          console.log('deu certo...');
          console.log(formData);
        }, (error: any) => {
          console.log(error);
          that.alertProvider.doAlert(error._body, 'Atenção');
          observer.next(null);
          observer.complete();
        });
    });
  }

  //  public doBilletVindi(formData, paymentType){
  //    let headers = this.authProvider.createApplicationHeadersWithBearer();

  //    return this.http.post(Config.baseUrl + '/users/me/vindi/' + paymentType, formData, { headers: headers}).map((res: Response) => res.json());
  //}

  public doBillet(formData: any) {
    let headers = this.createApplicationHeadersWithBearer();
    let that = this;
    let loader = this.loadingCtrl.create({
      content: 'Gerando o Boleto, aguarde ....',
      //duration: 3000
    });

    let voucherId = null;
    let voucherDiscountTotal = null;
    if (formData.voucherId !== undefined) {
      voucherId = formData.voucherId;
      voucherDiscountTotal = formData.voucherDiscountTotal;
    }

    loader.present();
    return Observable.create((observer: any) => {
      this.http.post(Config.baseUrlGateway + 'billet', formData, {headers: headers})

        .subscribe((formData) => {
          if (formData.ok === true) {
            let dataNewSubscription = formData.json();

            dataNewSubscription['voucherId'] = voucherId;
            dataNewSubscription['voucherDiscountTotal'] = voucherDiscountTotal;

            this.subscriptionServerProvider.doSubByPaymentBillet(dataNewSubscription).subscribe((data: any) => {
              loader.dismiss();
              this.showInsertOkBillet();
              //  this.navCtrl.setRoot('MainPage');
              //  this.navCtrl.popToRoot({
              //    animation: 'ios-transition'
              //  });
            });
          }
        }, (error: any) => {
          console.log(error);
          loader.dismiss();
          that.alertProvider.doAlert(error._body, 'Atenção');
          observer.next(null);
          observer.complete();
        });
    });

  }

  public doPix(formData: any) {
    let headers = this.createApplicationHeadersWithBearer();
    let that = this;
    let loader = this.loadingCtrl.create({
      content: 'Gerando o pix, aguarde ....',
      //duration: 3000
    });

    let voucherId = null;
    let voucherDiscountTotal = null;
    if (formData.voucherId !== undefined) {
      voucherId = formData.voucherId;
      voucherDiscountTotal = formData.voucherDiscountTotal;
    }

    loader.present();
    return Observable.create((observer: any) => {
      this.http.post(Config.baseUrlGateway + 'pix', formData, {headers: headers})

        .subscribe((formData) => {

          if (formData.ok === true) {
            let dataNewSubscription = formData.json();

            dataNewSubscription['voucherId'] = voucherId;
            dataNewSubscription['voucherDiscountTotal'] = voucherDiscountTotal;

            this.subscriptionServerProvider.doSubByPaymentPix(dataNewSubscription).subscribe((data: any) => {
              loader.dismiss();
              this.showInsertOkBillet();
              //  this.navCtrl.setRoot('MainPage');
              //  this.navCtrl.popToRoot({
              //    animation: 'ios-transition'
              //  });
            });
          }
        }, (error: any) => {
          console.log(error);
          loader.dismiss();
          that.alertProvider.doAlert(error._body, 'Atenção');
          observer.next(null);
          observer.complete();
        });
    });
  }

  public doCreditCard(formData: any) {
    let headers = this.createApplicationHeadersWithBearer();
    console.log('doCreditCard AFTER', formData);
    let that = this;
    let loader = this.loadingCtrl.create({
      content: 'Gerando o Pagamento, aguarde ....',
      //duration: 3000
    });

    let voucherId = null;
    let voucherDiscountTotal = null;
    if (formData.voucherId !== undefined) {
      voucherId = formData.voucherId;
      voucherDiscountTotal = formData.voucherDiscountTotal;
    }

    loader.present();
    return Observable.create((observer: any) => {
      this.http.post(Config.baseUrlGateway + 'credit_card', formData, {headers: headers})
        .subscribe((formData) => {
          if (formData.ok === true) {
            let dataNewSubscriptionByCC = formData.json();

            dataNewSubscriptionByCC['voucherId'] = voucherId;
            dataNewSubscriptionByCC['voucherDiscountTotal'] = voucherDiscountTotal;

            this.subscriptionServerProvider.doSubByPaymentCreditCard(dataNewSubscriptionByCC).subscribe((data: any) => {
              if (data.result === true) {
                loader.dismiss();
                this.showInsertOkCreditCard();
              }
            });
          }
        }, (error: any) => {
          console.log(error);
          loader.dismiss();
          that.alertProvider.doAlert(error._body, 'Atenção');
          let clicked = false;
          observer.next(null);
          observer.complete();
        });
    });

  }

  // private paymentRelease(id: number) {
  //   let url = Config.baseUrl + '/subscriptions/' + id + '/payment/release';
  //   return this.http.get(url)
  //     .map((res: Response) => res.json());
  // }

  showInsertOkBillet() {
    let that = this;
    let alert = this.alertCtrl.create({
      title: 'Inscrição solicitada!',
      message: 'Realize seu login novamente para dar continuidade no processo de Certificação! Você encontrará os dados para pagamento por meio da tela de "Histórico de Inscrição"!',
      enableBackdropDismiss: false,
      buttons: [
        {
          text: 'Ok',
          handler: () => {
            that.systemProvider.close();
          }
        }
      ]
    });
    alert.present();
  }

  showInsertOkFree() {
    let that = this;
    let alert = this.alertCtrl.create({
      title: 'Prova liberada!',
      message: 'Seu voucher foi validado e a prova ja esta disponível.',
      enableBackdropDismiss: false,
      buttons: [
        {
          text: 'Ok',
          handler: () => {
            that.systemProvider.close();
          }
        }
      ]
    });
    alert.present();
  }

  showInsertOkCreditCard() {
    let that = this;
    let alert = this.alertCtrl.create({
      title: 'Pagamento efetivado com sucesso!',
      message: 'Acesse novamente com seu login e senha e sua prova estará disponível através do menu "Realizar prova". Acesse esse menu e boa sorte!',
      enableBackdropDismiss: false,
      buttons: [
        {
          text: 'Ok',
          handler: () => {
            this.storage.remove('HASH');
            this.storage.remove('creditCardToken');
            that.systemProvider.close();
            // To do: Clear "HASH" "creditCardToken" from storage.
          }
        }
      ]
    });
    alert.present();
  }

  // public removeCheckoutData() {
  //   //this.newSubscription = null;
  // }
//
//   public doVerification(data: any): Observable<any[]> {
//     let that = this;
//
//     return Observable.create((observer: any) => {
//
//       if (!this.networkMonitorProvider.isOnline()) {
//
//         this.alertProvider.doAlert('É necessário estar conectado na Internet para realizar a verificação dos seus dados.', 'Atenção');
//
//         observer.next(null);
//         observer.complete();
//
//       } else {
//
//         let loader = this.loadingCtrl.create({
//           content: 'Verificando...',
//           //duration: 3000
//         });
//         loader.present();
//
//         // console.log(Config.baseUrl + '/users/registration/verify');
//         // console.log(data);
//
//         this.http.post(Config.baseUrl + '/users/registration/verify', data)
//           .map((res: Response) => res.json())
//           .subscribe((response: any) => {
//
//             console.log(response);
//             loader.dismiss();
//
//             observer.next(response.response.emails);
//             observer.complete();
//
//           }, (error: any) => {
//
//             console.log(error);
//             loader.dismiss();
//             that.alertProvider.doAlert('Houve problemas ao verificar suas informações.', 'Atenção');
//
//             observer.next(null);
//             observer.complete();
//
//           });
//
//       }
//     });
//   }


}



// WEBPACK FOOTER //
// ./src/providers/payment-http/payment-http.ts